import katex from 'katex';
import 'katex/dist/katex.css';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { useEffect, useRef } from 'react';
import { getQuillOptions } from '../../utils/getQuillOptions.js';
import { isQuillEmptyContents } from '../../utils/isQuillEmptyContents.js';
import './quill.css';
import { tryParseQuillContents } from '../../utils/tryParseQuillContents.js';

// @ts-ignore
globalThis.katex = katex;

function QuillWrapper({
  value,
  onChange,
  initialForceOpen,
}: {
  value: string;
  onChange?: (value: string) => void;
  initialForceOpen?: boolean;
}) {
  const ref = useRef(null);
  const wrapper = useRef(null);
  const quillRef = useRef(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return () => {};
    }
    const options = getQuillOptions();
    const quill = new Quill(element, options);
    quillRef.current = quill;
    const handleTextChange = (event) => {
      if (!onChange) {
        return;
      }
      const contents = quill.getContents();
      if (isQuillEmptyContents(contents)) {
        onChange('');
        return;
      }
      onChange(JSON.stringify(contents));
    };
    quill.on('text-change', handleTextChange);

    const handleMouseDown = (event) => {
      event.preventDefault();
    };
    const toolbar = wrapper.current.querySelector('.ql-toolbar');
    if (toolbar) {
      // https://github.com/zenoamaro/react-quill/issues/360
      toolbar.addEventListener('mousedown', handleMouseDown);
    }
    return () => {
      if (toolbar) {
        toolbar.removeEventListener('mousedown', handleMouseDown);
      }
      quill.off('text-change', handleTextChange);
      quill.container.remove();
    };
  }, [onChange]);

  useEffect(() => {
    const quill = quillRef.current;
    if (!quill) {
      return;
    }
    if (initialForceOpen) {
      quill.focus();
    }
  }, [initialForceOpen]);

  useEffect(() => {
    const quill = quillRef.current;
    if (!quill) {
      return;
    }
    const existing = quill.getContents();
    if (JSON.stringify(existing) === value) {
      return;
    }
    const parsed = tryParseQuillContents(value);
    quill.setContents(parsed);
  }, [value]);

  return (
    <div ref={wrapper}>
      <div id="quill" ref={ref} />
    </div>
  );
}

export default QuillWrapper;
